export function getServerObject() {
  if (
    window.hasOwnProperty('_serverObject') &&
    window._serverObject !== '{{ invoice_params }}'
  ) {
    try {
      return JSON.parse(atob(window._serverObject));
    } catch (e) {}
  }
}

export function decodeUriString(string) {
  return decodeURIComponent((string + '').replace(/\+/g, '%20'));
}

export function parseSearchParams(searchString) {
  const search = (searchString + '').split('&');

  if (search.length === 0) return {};

  return search.reduce((previous, current) => {
    if (current === '') return previous;

    const [key, value] = splitWithTail(current, '=', 1);

    try {
      previous[decodeUriString(key)] = decodeUriString(value || '');
    } catch (e) {}

    return previous;
  }, {});
}

export function maskSearchParam(url, paramName, mask, number) {
  if (url.indexOf(`${paramName}=`) > -1) {
    const value = url.split(`${paramName}=`)[1].split('&')[0];
    const maskedValue = mask + value.slice(-number);

    const urlWithValue =
      url.split(value)[0] + maskedValue + url.split(value)[1];

    return urlWithValue;
  } else {
    return url;
  }
}

export function isArray(a) {
  return Array.isArray(a);
}

export function isObject(o) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function';
}

export function toCamel(s) {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1
      .toUpperCase()
      .replace('-', '')
      .replace('_', '');
  });
}

export function snakeToCamel(o, blacklist) {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach((k) => {
      if (typeof blacklist == 'undefined' || blacklist.indexOf(k) === -1) {
        n[toCamel(k)] = snakeToCamel(o[k], blacklist);
      } else {
        n[toCamel(k)] = o[k];
      }
    });

    return n;
  } else if (isArray(o)) {
    return o.map((i) => {
      return snakeToCamel(i, blacklist);
    });
  }

  return o;
}

export function entries(obj) {
  let ownProps = Object.keys(obj),
    i = ownProps.length,
    resArray = new Array(i); // preallocate the Array
  while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

  return resArray;
}

export function splitWithTail(str, delim, count) {
  const parts = str.split(delim);
  const tail = parts.slice(count).join(delim);
  const result = parts.slice(0, count);
  result.push(tail);
  return result;
}

export function arrayToObject(array) {
  return array.reduce((obj, item) => {
    obj[item.key] = item.value;
    return obj;
  }, {});
}
